export default {
    'widgets.swap-form.header.swap': 'تبديل',
    'widgets.swap-form.input.title.you_pay': 'أنت تدفع',
    'widgets.swap-form.input.title.you_receive': 'أنت تتلقى',
    'widgets.swap-form.input.balance.balance': 'الرصيد',
    'widgets.swap-form.fusion-info.slippage-tolerance': 'تحمل الانزلاق',
    'widgets.swap-form.fusion-info.auction-time': 'وقت المزاد',
    'widgets.swap-form.fusion-info.min-receive': 'الحد الأدنى للاستلام',
    'widgets.swap-form.fusion-info.net-fee': 'رسوم الشبكة',
    'widgets.swap-form.swap-button.confirm-swap': 'تأكيد التبديل',
    'widgets.swap-form.swap-button.check-allowance': 'تحقق من المخصص',
    'widgets.swap-form.swap-button.native-token-not-supported': 'الرمز الأصلي غير مدعوم حاليًا',
    'widgets.swap-form.swap-button.approve-and-swap': 'الموافقة والتبديل',
    'widgets.swap-form.swap-button.permit-and-swap': 'السماح والتبديل',
    'widgets.swap-form.swap-button.connect-wallet': 'توصيل المحفظة',
    'widgets.swap-form.swap-button.select-source-token': 'اختر رمز المصدر',
    'widgets.swap-form.swap-button.select-destination-token': 'اختر رمز الوجهة',
    'widgets.swap-form.swap-button.enter-amount-to-swap': 'أدخل المبلغ للتبديل',
    'widgets.swap-form.swap-button.no-liquidity-for-swap': 'لا توجد سيولة للتبديل',
    'widgets.swap-form.swap-button.insufficient-balance': 'رصيد {{symbol}} غير كافٍ',
    'widgets.swap-form.swap-button.set-max': 'تعيين الحد الأقصى {{symbol}}',
    'widgets.swap-form.swap-button.wait-wallet-response': 'انتظر استجابة المحفظة',
    'widgets.swap-form.swap-button.permit-swap-in-wallet': 'السماح بالتبديل في المحفظة',
    'widgets.swap-form.swap-button.allow-swap-in-wallet': 'السماح بالتبديل في المحفظة',
};
//# sourceMappingURL=ar.js.map